import React from 'react'

import { WizardStepRenderParams } from '@factorialco/deprecated-design-system'
import { AccessForSelectFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { BankAccountMembershipSelector } from 'modules/banking/components/BankAccountMembershipSelector'

import { WizardManualAccountData } from '../../types'
import { WizardStepLayout } from '../WizardStepLayout'

export const MembershipsStep = ({
  data,
  onDataChanged,
}: WizardStepRenderParams<WizardManualAccountData>) => {
  const [selectedAccesses, setSelectedAccesses] = React.useState<AccessForSelectFragment[]>()
  const handleSelectAccesses = (newAccesses: AccessForSelectFragment[]) => {
    setSelectedAccesses(newAccesses)
    onDataChanged({ ...data, membershipsIds: newAccesses.map((access) => access.id) })
  }

  return (
    <WizardStepLayout
      title={i18n.t('banking.accounts.finish_wizard.step_3.title')}
      subtitle={i18n.t('banking.accounts.finish_wizard.step_3.subtitle')}
    >
      <BankAccountMembershipSelector
        selectedAccesses={selectedAccesses}
        handleSelectAccesses={handleSelectAccesses}
      />
    </WizardStepLayout>
  )
}
